import { render } from "./TicketAdd.vue?vue&type=template&id=358de223"
import script from "./TicketAdd.vue?vue&type=script&lang=ts"
export * from "./TicketAdd.vue?vue&type=script&lang=ts"
script.render = render

export default script